import { DetailedHTMLProps, OlHTMLAttributes } from "react";

export default function OrderedList(props: DetailedHTMLProps<OlHTMLAttributes<HTMLOListElement>, HTMLOListElement>) {
  return <ol {...props}>{props.children}</ol>;
}
